<div class="add-template-profile-dialog">
  <div class="dialog-header">
    <h2>{{ 'users:usergroups_addtemplateprofile_header' | i18next }}</h2>
         <app-basic-button type="ghost" isIcon="true" size="medium" (click)="onCancel()" aria-label="Close">
      <i class="far fa-times fs-16"></i>
     </app-basic-button>
  </div>

  <div class="dialog-content">
    <div class="template-list">
      <div
        class="template-item"
        *ngFor="let template of data.templateProfiles"
        [class.selected]="isSelected(template)"
        (click)="onTemplateSelect(template)">
        <label class="template-checkbox-label" (click)="$event.stopPropagation()">
          <app-basic-checkbox
            [model]="isSelected(template)"
            (modelChange)="onTemplateSelect(template)"
            class="template-checkbox"></app-basic-checkbox>
          <span class="template-name">{{ template.name }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <app-basic-button
      type="primary"
      size="medium"
      (click)="onAdd()"
      [disabled]="!canAdd()">
      <i class="fas fa-plus"></i>
      <span>{{ 'users:shared_addProfile' | i18next }}</span>
      <span *ngIf="getSelectedCount() > 0" class="selected-count">({{ getSelectedCount() }})</span>
    </app-basic-button>
  </div>
</div>

